import { render } from "./ContactContainer.vue?vue&type=template&id=0464d892&scoped=true"
import script from "./ContactContainer.vue?vue&type=script&lang=js"
export * from "./ContactContainer.vue?vue&type=script&lang=js"

import "./ContactContainer.vue?vue&type=style&index=0&id=0464d892&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0464d892"]])

export default __exports__